import { render, staticRenderFns } from "./_list.vue?vue&type=template&id=336aff02&scoped=true"
import script from "./_list.vue?vue&type=script&lang=js"
export * from "./_list.vue?vue&type=script&lang=js"
import style0 from "./_list.vue?vue&type=style&index=0&id=336aff02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336aff02",
  null
  
)

export default component.exports